import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bolt",
  "use": "icon-bolt-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bolt\"><path d=\"M13.5 2.5 5 13.5h5.5l-1 8 9.5-11h-5.5z\" fill=\"currentColor\" fill-opacity=\".14\" stroke=\"currentColor\" stroke-width=\"1.3\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol